import { gql } from 'urql';

export const STORE_CREDIT_FRAGMENT = gql`
  fragment storeCreditFields on StoreCredit {
    amount
  }
`;
